import { useEffect } from 'react';

interface UseKeyboardProps {
  onEscape?: () => void;
  onEnter?: () => void;
  enabled?: boolean;
  enableEnter?: boolean;
}

export const useKeyboard = ({
  onEscape,
  onEnter,
  enabled = true,
  enableEnter = true
}: UseKeyboardProps) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onEscape) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to parent handlers
        onEscape();
      } else if (e.key === 'Enter' && enableEnter && onEnter) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to parent handlers
        onEnter();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onEscape, onEnter, enabled, enableEnter]);
};